import React, { Component } from "react";
import { connect } from "react-redux";
import { METRIC, IMPERIAL } from "../../lib/types";
import { Document, Page, PDFViewer, Text, View, Image, Link as PDFLink } from "@react-pdf/renderer";
import "./index.css";
import PDFReportStyles from "./pdfreport.stylesheet";
import { regionIds } from "../../lib/localization/regionIds";
import MultiBedService from "../../lib/services/multibed-service";

let logoImg = require("../../media/cultec-stormgenie-logo.png");
const styles = PDFReportStyles;

class MBPDFReport extends Component{

  state = {
    showPDF: false,
    processedBeds: []
  };

  formatNum = ( val ) => {
    if (val && typeof val === "number") {
      if (Number.isInteger(val)) {
        return Math.floor(val);
      } else {
        return val.toFixed(2);
      }
    } else {
      return val;
    }
  };

  hasOutletStructure = ( bed ) => {
    if (bed.calculations.hasOutlet) {
      return this.props.content[this.props.lang].yes;
    } else {
      return this.props.content[this.props.lang].no;
    }
  };

  async componentDidMount() {
    MultiBedService.getMultibedDataForPDF(this.props)
      .then(( dt ) => {
        this.setState({
          processedBeds: [...dt],
          showPDF: true
        });
      });
  }

  render() {
    const {
      lbl,
      unit,
      lang,
      user,
      content,
      projectInfo,
      hasImperviousLiner
    } = this.props;

    let project = this.props.project || projectInfo;
    let fullName = "N/A";
    if (user) {
      fullName = `${user.givenName} ${user.surname}`;
    }

    const convertUnits = ( value, unitType ) => {
      let unitValue = 0;
      switch (unit) {
        case METRIC:
          switch (unitType) {
            case "ft": // Feets to meters
              unitValue = parseFloat(Math.ceil(( value * 0.3048 ) * 100) / 100).toFixed(2);
              break;
            case "in": // Inches to milimeters
              unitValue = Math.ceil(Math.ceil(( value * 25.4 ) * 100) / 100);
              break;
            case "sf": //
              unitValue = parseFloat(Math.ceil(( value / 10.764 ) * 100) / 100).toFixed(2);
              break;
            case "cf": // Cubic feets to cubic meters
              unitValue = parseFloat(Math.ceil(( value / 35.315 ) * 100) / 100).toFixed(2);
              break;
            case "cy": // Cubic yards to cubic meters
              unitValue = parseFloat(Math.ceil(( value / 1.308 ) * 100) / 100).toFixed(2);
              break;
            case "sy": // Square yards to square meters
              unitValue = parseFloat(Math.ceil(( value / 1.196 ) * 100) / 100).toFixed(2);
              break;
            default:
              unitValue = Math.ceil(value * 100) / 100;
              break;
          }
          break;
        case IMPERIAL:
          unitValue = this.formatNum(value);
          break;
        default:
          break;
      }
      return unitValue;
    };

    return (
      <React.Fragment>
        {this.state.showPDF
          ? (
            <PDFViewer style={styles.viewer}>
              <Document
                style={styles.document}
                onRender={this.handleOnRender}
                title={content[lang].adsPdfReport}
                author={content[lang].adsDesignTool}
                creator={content[lang].adsDesignTool}
                producer={content[lang].adsDesignTool}
                subject={content[lang].adsCalculationsReport}
                keywords={"ADS Design Tool, Advance Solutions, Report, PDF, Calculations"}
              >
                {( this.state.processedBeds && this.state.processedBeds.length > 0 )
                  ? this.state.processedBeds
                    .map(( bed ) => {

                      let crossSectionPrefix = this.props.lang.substring(0, 2);
                      if (crossSectionPrefix === "fr" && this.props.region.id === regionIds.europe)
                        crossSectionPrefix += "FR";
                      const sectionImages = {
                        "MC-7200": require(`../../media/PDFReport/${crossSectionPrefix}/MC-7200_CrossSection.png`),
                        "MC-4500": require(`../../media/PDFReport/${crossSectionPrefix}/MC-4500_CrossSection.png`),
                        "DC-780": require(`../../media/PDFReport/${crossSectionPrefix}/DC-780_CrossSection.png`),
                        "C-100HD": require(`../../media/PDFReport/${crossSectionPrefix}/C-100HD_CrossSection.png`),
                        "SC-160LP": require(`../../media/PDFReport/${crossSectionPrefix}/SC-160LP_CrossSection.png`),
                        "SC-310": require(`../../media/PDFReport/${crossSectionPrefix}/SC-310_CrossSection.png`),
                        "SC-740": require(`../../media/PDFReport/${crossSectionPrefix}/SC-740_CrossSection.png`)
                      };
                      const img = sectionImages[bed.globals.chamberType.id];
                      return (
                        <Page key={bed.id} wrap={false}>

                          <View style={styles.headerView}>
                            <Image
                              style={styles.logoImgStyle}
                              src={logoImg}
                            />
                          </View>

                          <View style={styles.rowView}>

                            <View style={styles.colView}>

                              {/*USER INPUTS COL*/}
                              <Text style={styles.titleText}>{content[lang].userInputs}</Text>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>{content[lang].chamberModel} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>{bed.chamberTypeName}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].outletControlStructure} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>{this.hasOutletStructure(bed)}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>{content[lang].projectName} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>{project.projectName}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>{content[lang].bedName} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>{bed.name}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>{content[lang].engineer} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>{fullName}</Text>
                                </View>

                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].projectLocation} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>{project.state}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].measurementType} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{unit.charAt(0).toUpperCase() + unit.slice(1)}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].requiredStorageVolume} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{convertUnits(bed.calculations.storageVolume, "cf")} {lbl[unit].cubicFeet[lang]}.</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].stonePorosityPdf} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{this.formatNum(bed.calculations.porosityPercent)}%</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].stoneFoundationDepth} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{convertUnits(bed.calculations.porousStoneBelow, "in")} {lbl[unit].in[lang]}.</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].stoneAboveChambersMsg}: </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{convertUnits(bed.calculations.porousStoneAbove, "in")} {lbl[unit].in[lang]}.</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].averageCoverOverChambers} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{convertUnits(bed.calculations.averageCover, "in") | 0} {lbl[unit].in[lang]}.</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>
                                    {content[lang].designConstraintDimensions}
                                  </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>
                                    ({convertUnits(bed.calculations.availableWidth, "ft")} {lbl[unit].ft[lang]}.
                                    x {convertUnits(bed.calculations.availableLength, "ft")} {lbl[unit].ft[lang]}.)
                                  </Text>
                                </View>
                              </View>
                            </View>

                            <View style={styles.colView}>
                              {/*RESULTS COL*/}
                              <Text style={styles.titleText}>{content[lang].results}</Text>
                              {/*SYSTEM VOLUME AND BED SIZE*/}
                              <Text style={styles.titleText}>{content[lang].systemVolumeAndBedSize}</Text>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].installedStorageVolume}</Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>
                                    {convertUnits(bed.calculations.totalStorageProvided, "cf")} {lbl[unit].cubicFeet[lang]}.
                                  </Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].storageVolumePerChamber} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>
                                    {convertUnits(bed.globals.chamberType.storage, "cf")} {lbl[unit].cubicFeet[lang]}.
                                  </Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].numberOfChambersRequired} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{this.formatNum(bed.calculations.requiredChambers) || 0}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].numberOfEndCapsRequired} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{this.formatNum(bed.calculations.requiredEndCaps) || 0}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>{content[lang].chamberRows} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{this.formatNum(bed.calculations.numberOfRows) || 0}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>{content[lang].maximumLength}</Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{convertUnits(bed.calculations.systemLength, "ft") || 0} {lbl[unit].ft[lang]}.</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>{content[lang].maximumWidth} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{convertUnits(bed.calculations.systemWidth, "ft") || 0} {lbl[unit].ft[lang]}.</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].approxBedSizeRequired} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>
                                    {convertUnits(bed.calculations.rectangularFootprint, "sf") || 0} {lbl[unit].squareFeet[lang]}.
                                  </Text>
                                </View>
                              </View>

                              {/*SYSTEM COMPONENTS*/}
                              <Text style={styles.titleText}>{content[lang].systemComponents}</Text>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].amountOfStoneRequired} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>
                                    {Math.ceil(convertUnits(( bed.calculations.amountOfStone / Math.pow(3, 3) )), "cy") || 0} {lbl[unit].cubicYard[lang]}
                                  </Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text
                                    style={styles.tableTextBold}>{content[lang].volumeOfExcavation} </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>
                                    {Math.ceil(
                                      convertUnits(
                                        ( this.props.calculations.totalExcavation / Math.pow(3, 3) ),
                                        "cy"
                                      )
                                    ) || 0}{" "}
                                    {lbl[unit].cubicYard[lang]}
                                  </Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>{content[lang].totalNonWoven}</Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{Math.ceil(convertUnits(( bed.calculations.geotextileQuantities.nonWovenTotal || 0 )), "sy") || 0} {lbl[unit].squareYard[lang]}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>{content[lang].woven}</Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{Math.ceil(convertUnits(bed.calculations.geotextileQuantities.woven, "sy")) || 0} {lbl[unit].squareYard[lang]}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>{content[lang].wovenIsolator}</Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>{Math.ceil(convertUnits(bed.calculations.geotextileQuantities.wovenIsolator, "sy")) || 0} {lbl[unit].squareYard[lang]}</Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>{content[lang].totalWoven}</Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text
                                    style={styles.tableText}>
                                    {Math.ceil(convertUnits(( bed.calculations.geotextileQuantities.wovenTotal || 0 )), "sy") || 0} {lbl[unit].squareYard[lang]}
                                  </Text>
                                </View>
                              </View>

                              <View style={styles.rowView}>
                                <View style={styles.innerLColView}>
                                  <Text style={styles.tableTextBold}>
                                    {content[lang].imperviousLinerRequired}
                                  </Text>
                                </View>
                                <View style={styles.innerRColView}>
                                  <Text style={styles.tableText}>
                                    {Math.ceil(
                                      convertUnits(
                                        bed.calculations.linerSqInchOverage,
                                        "sy"
                                      )
                                    ) || 0}{" "}
                                    {lbl[unit].squareYard[lang]}
                                  </Text>
                                </View>
                              </View>

                            </View>
                          </View>

                          {hasImperviousLiner ?
                            <View style={styles.rowView}>
                              <View style={styles.fullColView}>
                                <Text style={styles.tableTextBold}>
                                  {content[lang].imperviousLinerNotes}
                                </Text>
                                <Text style={styles.tableText}>
                                  <PDFLink
                                    href="https://assets.ads-pipe.com/m/43dc1a1b8b189a34/original/TN-6-50-Thermoplastic-Liners-for-Detention-Systems.pdf">
                                    {content[lang].technicalNote650}
                                  </PDFLink>
                                </Text>
                                <Text style={styles.tableText}>
                                  {content[lang].technicalNotes}
                                </Text>
                              </View>
                            </View>
                            : null}

                          <View style={styles.contentView}>
                            <Image
                              style={styles.sectionImgStyle}
                              src={img}
                            />
                          </View>
                        </Page> );
                    })
                  : null
                }
              </Document>
            </PDFViewer>
          ) : ( <p>...</p> )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.authentication.user,
    resourcesTokens: state.authentication.resourcesTokens,

    lbl: state.localization.lbl,
    unit: state.localization.unit,
    globals: state.globals,
    lang: state.localization.lang,
    region: state.localization.region,
    project: state.project.project,

    calculations: state.calculations,
    content: state.localization.content,
    chamberType: state.globals.chamberType,
    projectInfo: state.project.projectInfo,
    hasOutlet: state.calculations.hasOutlet,
    parameters: state.calculations.parameters,
    systemWidth: state.calculations.systemWidth,
    averageCover: state.calculations.averageCover,
    systemLength: state.calculations.systemLength,
    storageVolume: state.calculations.storageVolume,
    availableWidth: state.calculations.availableWidth,
    availableLength: state.calculations.availableLength,
    porosityPercent: state.calculations.porosityPercent,
    porousStoneAbove: state.calculations.porousStoneAbove,
    porousStoneBelow: state.calculations.porousStoneBelow,
    chamberStorageVolume: state.globals.chamberType.storage,
    totalStorageProvided: state.calculations.totalStorageProvided,
    chamberEndCapTypeStorage: state.globals.chamberEndCapType.storage,
    hasImperviousLiner: state.calculations.hasImperviousLiner
  };
};

export default connect(
  mapStateToProps,
  {}
)(MBPDFReport);



// WEBPACK FOOTER //
// ./src/components/PDFReport/mb_index.js